import type { createHTTPClient } from '@medizzy/http-client';
import { proxy } from 'valtio';

export const clientProxy = proxy({
  client: {} as ReturnType<typeof createHTTPClient>,
});
